import { isDef as O } from "../shared/index.mjs";
import { getCurrentInstance as $, ref as h, watch as V, nextTick as E, computed as F } from "vue";
function w(i) {
  return JSON.parse(JSON.stringify(i));
}
function I(i, n, N, S = {}) {
  var f, c, a;
  const {
    clone: r = !1,
    passive: _ = !1,
    eventName: b,
    deep: d = !1,
    defaultValue: J,
    shouldEmit: m
  } = S, t = $(), g = N || (t == null ? void 0 : t.emit) || ((f = t == null ? void 0 : t.$emit) == null ? void 0 : f.bind(t)) || ((a = (c = t == null ? void 0 : t.proxy) == null ? void 0 : c.$emit) == null ? void 0 : a.bind(t == null ? void 0 : t.proxy));
  let l = b;
  n || (n = "modelValue"), l = l || `update:${n.toString()}`;
  const v = (e) => r ? typeof r == "function" ? r(e) : w(e) : e, p = () => O(i[n]) ? v(i[n]) : J, x = (e) => {
    m ? m(e) && g(l, e) : g(l, e);
  };
  if (_) {
    const e = p(), s = h(e);
    let o = !1;
    return V(
      () => i[n],
      (u) => {
        o || (o = !0, s.value = v(u), E(() => o = !1));
      }
    ), V(
      s,
      (u) => {
        !o && (u !== i[n] || d) && x(u);
      },
      { deep: d }
    ), s;
  } else
    return F({
      get() {
        return p();
      },
      set(e) {
        x(e);
      }
    });
}
export {
  w as cloneFnJSON,
  O as isDef,
  I as useVModel
};
